import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Collapsible } from '@fiverr-private/fit';
import { numberFormat } from '@fiverr-private/localization';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import Collaborator from '../Collaborator';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { OPEN_COLLABORATOR_LIST, CLOSE_COLLABORATOR_LIST } from '../../../Utils/mixpanel/mixpanelEvents';
import * as Translations from '../../providers/i18n';
import './style.scss';

const Title = ({ i18n, count }) => (
    <div className="collaborators-list-title font-accent">
        <i className="collaborators-list-icon"/>{i18n.t('attachments_preview.collaborators.collaborators_title', { count })}
    </div>
);

Title.propTypes = {
    count: PropTypes.number,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export const CollaboratorsList = ({ collaboratorsIds, i18n }) => {
    const count = collaboratorsIds.length;

    if (!count) { return null; }

    const onMinimize = () => {
        sendMixPanelEvent({
            eventName: CLOSE_COLLABORATOR_LIST
        });
    };

    const onExpand = () => {
        sendMixPanelEvent({
            eventName: OPEN_COLLABORATOR_LIST
        });
    };

    const formattedCollaboratorsCount = numberFormat(count, {
        fallbackValue: count
    });

    return (
        <div className="collaborators-list">
            {<Collapsible title={<Title i18n={i18n} count={formattedCollaboratorsCount}/>} className="collaborators-list-collapsible" onExpand={onExpand} onMinimize={onMinimize}>
                <ul>
                    {collaboratorsIds.map((collaboratorId) => (
                        <Collaborator key={collaboratorId} collaboratorId={collaboratorId}/>
                    ))}
                </ul>
            </Collapsible>}
        </div>
    );
};

CollaboratorsList.propTypes = {
    collaboratorsIds: PropTypes.arrayOf(PropTypes.string),
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    collaboratorsIds: CollaboratorsSelectors.getCollaboratorIdsByGroupType(state, 'collaborators', {
        withoutRemoved: true, withoutCurrent: true, withoutAnonymous: true
    })
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(CollaboratorsList);
